import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { clearUnsaved } from "@/components/useDraftRows";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("pressops_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("pressops_user", JSON.stringify(data));
      setUser(data);
    } catch (e) {
      const cached = localStorage.getItem("pressops_user");
      setUser(!e.response && cached ? JSON.parse(cached) : false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pressops_token", data.token);
    localStorage.setItem("pressops_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    clearUnsaved();
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("pressops_token");
    localStorage.removeItem("pressops_user");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (u) => (u.role === "platform_admin" ? "/platform" : ["platform_ops", "support_l1", "support_l2"].includes(u.role) ? "/ops/tickets" : u.role === "customer" ? "/portal" : "/app");

export function useAccess() {
  const { user } = useAuth();
  const mode = user?.tenant?.access_mode || "full";
  const role = user?.role;
  return {
    mode,
    role,
    canWrite: (roles) => mode === "full" && (!roles || roles.includes(role)),
    currency: user?.tenant?.base_currency || "GHS",
  };
}
